/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Availability_WaitingInputs */

const en_queue_availability_waiting = /** @type {(inputs: Queue_Availability_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Availability rows to resolve`)
};

/**
* | output |
* | --- |
* | "Availability rows to resolve" |
*
* @param {Queue_Availability_WaitingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_availability_waiting = /** @type {((inputs?: Queue_Availability_WaitingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Availability_WaitingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_availability_waiting(inputs)
});